var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 7C4.86902 7 5.6875 6.18152 5.6875 5.17188C5.6875 4.16223 4.86902 3.34375 3.85938 3.34375C2.84973 3.34375 2.03125 4.16223 2.03125 5.17188C2.03125 6.18152 2.84973 7 3.85938 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94141 8.01562C5.22641 7.65254 4.43727 7.50781 3.85938 7.50781C2.72746 7.50781 0.40625 8.20199 0.40625 9.58984V10.6562H4.21484V10.2482C4.21484 9.7658 4.41797 9.28211 4.77344 8.87891C5.05705 8.55695 5.45416 8.25811 5.94141 8.01562Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63281 7.8125C7.31072 7.8125 4.67188 8.62906 4.67188 10.25V11.4688H12.5938V10.25C12.5938 8.62906 9.9549 7.8125 8.63281 7.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63281 7C9.86682 7 10.8672 5.99964 10.8672 4.76562C10.8672 3.53161 9.86682 2.53125 8.63281 2.53125C7.3988 2.53125 6.39844 3.53161 6.39844 4.76562C6.39844 5.99964 7.3988 7 8.63281 7Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.fc5d0d7779123fd9cf914bb4538330f4.svg";
export { ForwardRef as ReactComponent };